import React from "react"
import { Link } from "components/Link"
import type { ReactElement, ReactNode } from "react"

type Props = {
  variant?: string
  pdpUrl?: string | null
  dataTestId?: string
  children: ReactNode
}

export const ProductLink: React.FC<Props> = ({
  variant = "acuminLight",
  pdpUrl,
  dataTestId,
  children,
}): ReactElement => {
  if (!children) return <></>

  if (pdpUrl) {
    return (
      <Link data-testid={dataTestId} href={pdpUrl} variant={variant}>
        {children}
      </Link>
    )
  }

  return <>{children}</>
}
